//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
import { formulaDetail } from '../../../server/oldformula/'
export default {
  name: 'AbsoluteNeutrophilCount_info',
  data () {
    return {
      formulaInfo: {},
      content: [],
      refList: [],
      id: 'b23817e1e9b690382e81a3894e97901a'
    }
  },
  components: {
  },
  created () {
    this.hideLoad()
    this.getFormulaDetail()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    async getFormulaDetail () {
      var params = {
        uuid: this.id
      }
      try {
        const res = await formulaDetail(params)
        this.formulaInfo = res
        if (this.formulaInfo.introExplain) {
          this.content = JSON.parse(this.formulaInfo.introExplain)
        }
        if (this.formulaInfo.referenceNew) {
          this.refList = JSON.parse(this.formulaInfo.referenceNew)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/ID/AbsoluteNeutrophilCount_info.vue